import { produce } from "immer";
import { AnyAction } from "redux";

import { IUserState } from "../../auth/reducers";
import { GET_TEAM_SUCCESS, UPDATE_TEAM_MEMBER_AGENDA } from "../constants";

export interface IOperators {
  operators: ITeamMember[];
}

export interface ITeamMember {
  id: string;
  team: any;
  user: IUserState;
  isChecked: boolean;
  color: string;
}

export interface IUserMember {
  id: string;
  email: string;
  firstname: string;
  fullName: string;
  isValidPhoneNumber: boolean | null;
  lastname: string;
  phoneNumber: string | null;
}

const initState = {
  operators: [],
};

const getColor = (index: number) => {
  const colors = [
    "#4883F7",
    "#11BFA4",
    "#fdc200",
    "#FF0000",
    "#FF7D29",
    "#EF5DA8",
    "#000D5B",
    "#919191",
  ];
  const colorIndex = index % colors.length;

  return colors[colorIndex];
};

const teamReducer = produce((draft = initState, action: AnyAction) => {
  const operators: any[] = [];
  const index = action.payload?.index;
  const updates = action.payload?.updates;
  const memberToUpdate = draft.operators[index];
  switch (action.type) {
    case GET_TEAM_SUCCESS:
      action.payload.map((operator: any, index: number) => {
        operators.push({
          id: operator.id,
          team: operator.team,
          user: operator.user,
          isChecked: true,
          color: getColor(index),
        });
      });
      draft.operators = operators;
      break;
    case UPDATE_TEAM_MEMBER_AGENDA:
      if (memberToUpdate) {
        Object.assign(memberToUpdate, updates);
      }
      break;
    default:
      return draft;
  }
});

export default teamReducer;
